import { useCallback, useEffect, useState } from 'react';
import AACChromeAPI from '@amzn/aac-chrome-api';

const useIsCollapsed = () => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

  useEffect(() => {
    AACChromeAPI.getCommonEventTarget().addEventListener(
      'TogglePivotNav',
      toggleCollapse,
    );

    return () => {
      AACChromeAPI.getCommonEventTarget().removeEventListener(
        'TogglePivotNav',
        toggleCollapse,
      );
    };
  }, []);

  const toggleCollapse = useCallback(() => {
    setIsCollapsed((prevState) => !prevState);
  }, []);

  return { isCollapsed, toggleCollapse };
};

export default useIsCollapsed;
